<app-input
	[label]="label"
	[labelIcon]="AI_ICON"
	[labelToolTip]="(fieldMappings$ | async)?.purchasePrice ? AI_TOOLTIP : ''"
	[labelIconClasses]="AI_CLASSES"
	(onFocus)="_onFocus()"
	type="cents"
	(debounce)="onChange($event)"
	[ngModel]="salePrice$ | async"
	[startIcon]="ICON.DOLLAR"
	[orientation]="orientation"
	[skeletonLoading]="isLoading$ | async"
	[testHook]="testHooks.SalePrice"
></app-input>
